<div class="sales-chart">
  <mat-slide-toggle
    class="scale-break-toggle"
    color="primary"
    [checked]="scaleBreak"
    (change)="onScaleBreakToggle($event.checked)"
  >
    Scale break
  </mat-slide-toggle>
  <div echarts [options]="chartOption" class="chart"></div>
</div>